module.exports = __webpack_public_path__ + "img/chinesecompany36.058a9bae.png";